import classNames from 'classnames';
import { filterList } from 'helpers/filterDogList';
import { DataContext } from 'hooks/HeaderContext';
import React, { FC, useContext } from 'react';
import Select, { FormatOptionLabelMeta } from 'react-select';
import { DogSummary, FILTER_KEY } from 'types/Dog';
import { FilterSet, Option } from 'types/Option';
import ButtonGroupSelector from './ButtonGroupSelector';

interface Props {
    title: string;
    selectedFilters: Option[];
    filterOptions: Option[];
    onChange(options: Option[]): void;
    isMobile?: boolean;
    formatLabel?(option: Option): string;
}

const DogFilter: FC<Props> = ({ title, filterOptions, selectedFilters: selectedOptions, onChange, isMobile, formatLabel }) => {

    const {
        dogsWithinProximityList,
        selectedFilters
    } = useContext(DataContext);


    function retrieveExcludedFiles(option: Option): DogSummary[] {
        const myTypeExcluded = Object.keys(selectedFilters).filter(k => k !== FILTER_KEY[option.type]).reduce((newSet, current) => {
            newSet[current] = selectedFilters[current]
            return newSet;
        }, {}) as FilterSet
        return filterList(dogsWithinProximityList, myTypeExcluded);
    }



    const formatOptionLabel = (o: Option, meta: FormatOptionLabelMeta<Option>) => {
        const excludedFiles = retrieveExcludedFiles(o);
        const filterNumber = excludedFiles.filter(f => f[o.type] == o.value).length;
        if (meta.context === 'menu') {
            return <div className={classNames('d-flex w-100 justify-content-between flex-nowrap',
                {
                    'no-dog-count': filterNumber === 0
                }
            )}>
                <span className='me-5'>
                    {o.label}
                </span>
                <div className='d-flex flex-nowrap'>
                    <span>(</span>
                    {selectedOptions.length === 0
                        ? o.filteredCount
                        : filterNumber
                    }
                    <span>)</span>


                </div>
            </div>
        }
        return o.label
    }


    return (
        <>
            <div id={title} className="text-center h6 text-dark fw-bold">{title}</div>
            <div className={isMobile ? 'd-none d-lg-block' : ''}>
                <Select
                    aria-labelledby={title}
                    classNamePrefix='p4p-select'
                    placeholder='Any'
                    isClearable
                    isMulti
                    options={filterOptions}
                    value={selectedOptions}
                    onChange={onChange}
                    formatOptionLabel={formatOptionLabel}
                    menuPlacement='auto'
                />
            </div>

            {isMobile &&
                <div className='d-lg-none'>
                    <ButtonGroupSelector
                        options={filterOptions}
                        value={selectedOptions}
                        onChange={onChange}
                        formatLabel={formatLabel}
                    />
                </div>
            }
        </>

    )
}

export default DogFilter;




















